import { useDispatch } from "react-redux";
import NotificationCard from "./notificationCard";
import { useEffect, useState } from "react";
import { useAppBar } from "../../components/appBar/appBarContext";
import { changeRouteType, getpervInnerState } from "../../redux/handleBackBtn/handleBackBtnSlice";
import { setHeaderTitle } from "../../redux/headerTitle/headerTitleSlice";
import { UUID } from "../../config/cacheKey";
import { useMutation } from "react-query";
import { getNotices } from "../../services/notification.service";
import { IGetNoticesResponse } from "../../models/notification.model";
import EmptyNotification from "./emptyNotification";
import NotificationSkeleton from "./notificationSkeleton";


export default function Notifications() {
    const dispatch = useDispatch();
    const randomKeyForDispatch = Math.random();
    const [notice, setNotice] = useState<IGetNoticesResponse[]>();
    const [changeNoticeStatus, setChangeNoticeStatus] = useState(false);

    useEffect(() => {
        GetNoticesMutate();
    }, [changeNoticeStatus === true])
    useEffect(() => {
        GetNoticesMutate();
        dispatch(setHeaderTitle({ color: 'var(--header-color)', header: 'اطلاعیه ها', parentRoute: 'home' }));
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: `home ${randomKeyForDispatch}` }));
    }, [])
    const { mutate: GetNoticesMutate, isLoading } = useMutation(
        getNotices,
        {
            onSuccess: (data: IGetNoticesResponse[]) => {
                setNotice(data);
            },
        }
    );

    if (isLoading || notice === undefined) {
        return <NotificationSkeleton />
    } else {
        return (
            <>
                <div className="h-[calc(100svh-120px)] overflow-y-auto">
                    <div className='p-5'>
                        {
                            notice?.length! > 0 ?
                                notice?.map((item: any) =>
                                    <NotificationCard title={item.title} date={item.createDatePersian} setChangeNoticeStatus={setChangeNoticeStatus}
                                        seenDate={item.seenDate} noticeType={item.noticeType} id={item.id} description={item.description} />
                                ) : <EmptyNotification />
                        }
                    </div>

                </div>
            </>
        );
    }
}


